<template>
    <div>
        <div id="agentHome">
            <section class="section1">
                <h3>
                    <img src="./../../assets/agent/userImg.png" alt="" style="width:20px;height:22px;">
                    <span style="margin-top:4px;margin-left: 10px;color:#fff">{{ nickName }}</span>                
                </h3>
               <img src="./../../assets/agent/colse.png" alt="" style="width:18px;height:18px;">
            </section>
             <section class="section-data">
                 <div class="title">基本数据</div>
                <van-row class="vant-title">
                    <van-col span="12">本月订单</van-col>
                    <van-col span="12" class="vant-right">本月月结佣金</van-col>
                </van-row>
                <van-row class="vant-content">
                    <van-col span="12">{{ baseData.orderMonthCount || 0}}</van-col>
                    <van-col span="12" class="vant-right">{{baseData.commissionMonthCount || 0.00}}</van-col>
                </van-row>
             </section>
            <section class="section2" style="margin-top: 36px;">
                <ul>
                    <li>
                        <div>
                            <label>SIM卡总数</label>
                            <span>{{ baseData.simTotalCount || 0}}</span>
                        </div>
                        <div>
                            <label>本月立结佣金</label>
                            <span>{{ baseData.totalOnePrice || 0 }}</span>
                        </div>
                    </li>
                    <li>
                        <div>
                            <label>月结佣金</label>
                            <span>{{ baseData.myCommission || 0}}</span>
                        </div>
                        <div>
                            <label>累计月结佣金总额</label>
                            <span>{{ baseData.commissionTotalCount || 0}}</span>
                        </div>
                    </li>
                </ul>
            </section>
            <section class="section3">
                <h3>  
                    <span>基础操作</span>            
                </h3>
                <van-row style="margin-bottom:26px;">
                    <van-col span="6">
                        <a href="#/agent/card">
                             <img src="./../../assets/agent/icon9.png" alt="" style="width:26px;height:20px;">
                            <div>卡片管理</div>
                        </a>
                    </van-col>
                    <van-col span="6">
                        <a href="#/agent/myorder">
                             <img src="./../../assets/agent/icon4.png" alt="" style="width:26px;height:20px;">
                            <div>订单管理</div>
                        </a>
                    </van-col>
                    <van-col span="6">
                        <a href="#/agent/inentSim">
                             <img src="./../../assets/agent/icon5.png" alt="" style="width:26px;height:20px;">
                            <div>卡板充值</div>
                        </a>
                    </van-col>
                    
                     <van-col span="6">
                        <a href="#/agent/pkg">
                            <img src="./../../assets/agent/icon2.png" alt="" style="width:23px;height:23px;">
                            <div>套餐类别</div>                        
                        </a>
                    </van-col>
                    <van-col span="6">
                        <a href="#/agent/card2">
                            <img src="./../../assets/agent/icon6.png" alt="" style="width:23px;height:23px;">
                            <div>套餐分销</div>                        
                        </a>
                    </van-col>
                    <van-col span="6">
                        <a href="#/agent/withdrawal">
                            <img src="./../../assets/agent/icon8.png" alt="" style="width:25px;height:23px;">
                            <div>佣金提现</div>                                
                        </a>
                    </van-col>
                     <van-col span="6">
                        <a href="#/agent/myprice">
                            <img src="./../../assets/agent/icon10.png" alt="" style="width:23px;height:23px;">
                            <div>佣金明细</div>                        
                        </a>
                    </van-col>
                     <van-col span="6">
                        <a href="#/agent/buysim">
                            <img src="./../../assets/agent/icon1.png" alt="" style="width:23px;height:23px;">
                            <div>买卡列表</div>                        
                        </a>
                    </van-col>
                      <van-col span="6">
                        <a href="#/agent/notify">
                            <img src="./../../assets/agent/icon3.png" alt="" style="width:23px;height:23px;">
                            <div>公告</div>                        
                        </a>
                    </van-col>
                      <van-col span="6">
                        <a href="#/agent/addUser">
                            <img src="./../../assets/agent/icon7.png" alt="" style="width:23px;height:23px;">
                            <div>代理管理</div>                        
                        </a>
                    </van-col>
                    <van-col span="6">
                        <a href="#/agent/agentBindVx">
                            <img src="./../../assets/agent/icon5.png" alt="" style="width:22px;height:23px;">
                            <div>绑定收款微信</div>                                
                        </a>
                    </van-col>
                      <van-col span="6">
                        <a href="#/agent/card3">
                            <img src="./../../assets/agent/icon6.png" alt="" style="width:23px;height:23px;">
                            <div>立结套餐分销</div>                        
                        </a>
                    </van-col>
                </van-row>
                 <van-row>
                    <!-- <van-col span="6">
                        <a href="#/agent/secondBack">
                             <img src="./../../assets/agent/icon1.png" alt="" style="width:14px;height:23px;">
                            <div>秒返设置</div>
                        </a>
                    </van-col>
                    <van-col span="6">
                        <a href="#/agent/distribut">
                            <img src="./../../assets/agent/icon2.png" alt="" style="width:18px;height:23px;">
                            <div>SIM卡分销</div>                        
                        </a>
                    </van-col> -->
                    
                </van-row>
                  <!-- <ul>
                    <li>
                          
                      <a href="#/agent/recharge">
                            <svg class="icon" aria-hidden="true">
                                <use xlink:href="#se-icon-recharge"></use>
                            </svg> 
                            <label>预充值</label>                                
                        </a>
                        <a href="#/agent/rechargeRecord">
                            <svg class="icon" aria-hidden="true">
                                <use xlink:href="#se-icon-recharge-record"></use>
                            </svg> 
                            <label>预充值记录</label>                                
                        </a> 
                    </li>
                   <li>
                        <a href="https://tb.53kf.com/code/wx/c8a12b38134caf46a69c75534ba9e4011/1+">
                            <van-icon color="#ffa33a" size="24px" name="service-o" />
                            <label>在线客服</label>                                
                        </a>    
                    </li> 
                </ul> -->
            </section>
            <section style="margin:10px 14px;">
                <h3> 
                    <span>近7天订单数</span>     
                    <div id="weekData" ref="weekData" style="height:240px"></div>       
                </h3>
            </section>
        </div>

        <!-- <van-popup 
            closeable
            v-model="notifyPopup"
            position="top"
            :style="{ height: '50%' }" 
            v-if="this.$store.state.notifyAlreadyRead == false"
        >
            <div class="notifyPopup">
                <h1 >{{notify.title}}</h1>
                <p >{{notify.content}}</p>
                <div class="alreadyRead" @click="stopDefault" @touchmove="stopDefault">
                    <van-checkbox v-model="alreadyRead" shape="square">
                        <span style="color:#0092ff">我知道了</span>
                    </van-checkbox>
                </div>
            </div>
            
        </van-popup> -->
    </div>
    
</template>
<script>
import {wxRequest} from '@/api/agent.js';
var echarts = require('echarts/lib/echarts');// 引入 ECharts 主模块
require('echarts/lib/chart/line');// 引入折线图

export default {
    data(){
        return {
            nickName: localStorage.getItem('nickName'),
            baseData: {},
            notify:{
                title: '',
                content:'',
            },
            notifyPopup: true,
            alreadyRead: false,
        }
    },
    methods: {
        logouHandler(){
            this.$router.push('/agent/login');
        },
        getAgentBaseDataHandler(){
            var data = {
                account: localStorage.getItem('accountName')
            }
            wxRequest("agentCount/info", data, "get").then(res => {
                if(res.data.code == 200){
                    this.baseData = res.data.data;
                    var weekOrderList = this.baseData.weekOrderList;
                    var xAxisData = [], seriesData = [];
                    weekOrderList.forEach(item => {
                        xAxisData.push(item.orderTime)
                        seriesData.push(item.weekNumber)
                    });
                    this.drawEchart(xAxisData,seriesData);
                }else{
                    this.$messagebox.alert(res.data.message);
                }
            })
        },

        stopDefault( e ) { 
            console.log("----------1-----")
            //阻止默认浏览器动作(W3C) 
            if ( e && e.preventDefault ) {
                console.log("----------2-----")
                e.preventDefault(); 
            }
            //IE中阻止函数器默认动作的方式 
            else {
                console.log("----------3-----")
                window.event.returnValue = false; 
            }
            return false; 
        },

        drawEchart(xAxisData, seriesData){
            // 基于准备好的dom，初始化echarts实例
            // var myChart = echarts.init(document.getElementById('testMT'));
            var myChart = echarts.init(this.$refs.weekData);
            // 绘制图表
            myChart.setOption({
                xAxis: {
                    axisLine:{
                        lineStyle: {
                            color: '#EEF0F3',//左边线的颜色
                        }
                    },
                    axisLabel: {
                        textStyle: {
                            color: '#999',
                        },
                    },
                    splitLine: {
                        lineStyle: {
                            color: "#EEF0F3"
                        }
                    },
                    data: xAxisData,
                    boundaryGap: false
                },
                color:['#1677FE'],
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    top:'6%',
                    containLabel: true
                },
                yAxis: {
                    splitLine: {
                        lineStyle: {
                            color: "#EEF0F3"
                        }
                    },
                    axisLabel: {
                        textStyle: {
                            color: '#999',
                        },
                    },
                    axisLine: {
                        lineStyle: {
                            color: '#EEF0F3',
                        }
                    }
                },
                series: [{
                    name: '销量',
                    type: 'line',
                    itemStyle: {
                    normal: {
                        color: '#289df5', // 折线条的颜色
                        borderColor: '#289df5', // 拐点边框颜色
                        areaStyle: {
                            type: 'default',
                            opacity: 0.1
                        }
                    }
                },
                data: seriesData
                }]
            });
        },

        getNotifyListHandler(){
            this.pageNo += 1;
            var data = {
                pageNo: this.pageNo,
                perPageNum: this.perPageNum,
            }
            wxRequest("agentNotice/list", data, "post").then(res => {
                if(res.data.code == 200){
                    if(res.data.data.resultList!=null&&res.data.data.resultList.length>0){
                        this.notify = res.data.data.resultList[0]
                    }             
                }
            })
        },
    },
    created(){
        var appid = process.env.VUE_APP_APPID;
        var redirectUrl = window.location.href;
        var index = redirectUrl.indexOf('?');
        redirectUrl = encodeURIComponent(redirectUrl) 
        // if(index < 0){
        //     window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirectUrl}&response_type=code&scope=snsapi_userinfo#wechat_redirect`
        // }else{
        //     var search = window.location.search;
        //     var startIndex = search.indexOf('code');
        //     var endIndex = search.indexOf('&', startIndex);
        //     var str = search.slice(startIndex, endIndex);
        //     var code = str.slice(str.indexOf('=') + 1);
        //     var data = {
        //         code: code
        //     }
        //     wxRequest("sysUser/bind", data, "get")
        // }

        this.getNotifyListHandler();         
    },
    mounted(){
        this.getAgentBaseDataHandler();
        console.log("===="+this.$store.state.notifyAlreadyRead);
    },

    watch: {
        // 如果 `alreadyRead` 发生改变，这个函数就会运行
        alreadyRead: function () {
            this.$store.state.notifyAlreadyRead = this.alreadyRead;
        },
    },
}
</script>
<style lang="less" scoped>
#agentHome {
    background: #F5F5F5;
    position: relative;
    section {
        padding: 10px 8px;
        background: #fff;
        border-radius: 8px;
        h3 {
            span {
                display: inline-block;
                vertical-align: top;
                margin:6px 0 19px 16px;
                color:#000;
                font-weight:bold;
                font-size: 15px;
            }
        }
        &.section1 {
            display: flex;
            justify-content: space-between;  
            padding:24px 14px 0;
            border-radius:0;
            background: url(./../../assets/agent/icon10.png) no-repeat center;
            background-size: 100%;
            height:119px;
        }
        &.section-data{
            margin:0 14px;
            position: absolute;
            top: 60px;
            width: calc(100% - 28px);
            padding:0;
            .title{
                font-size:15px;
                padding-top:12px;
                padding-left:16px;
                padding-bottom:16px;
                color:#000;
                font-weight:bold;
            }
            .vant-title{
                padding:0 16px;
                .van-col--12{
                    color:#999;
                    font-size:14px;
                }
                .vant-right{
                    text-align:right;
                }
            }
            .vant-content{
                padding:16px;
                padding-top:8px;
                padding-bottom: 22px;
                .van-col--12{
                    color:#191919;
                    font-size:22px;
                }   
                .vant-right{
                    text-align:right;
                }
            }
        }
        &.section2, &.section3 {
            margin:10px 14px;
            ul {
                li {                    
                    display: flex;
                    /** justify-content: space-around; **/
                    line-height: 1.8em;
                    div,a {
                        width: 50%;
                        display: flex;
                        flex-direction: column;
                        padding-left: 16px;
                        // text-align: center;
                        label{
                            color:#999999;
                            font-size:13px;
                        }
                        padding-bottom:6px;
                        padding-top:6px;
                        border-bottom: 1px solid #F5F5F5;
                        border-left: 1px solid #F5F5F5;
                        &:nth-child(2n + 1) {
                            border-left: 0; 
                        }
                    }
                    &:nth-child(2n) {
                        div{
                            border-bottom: 0; 
                        }
                    }
                }                
            }
        }
        &.section3 {
            .van-row{
                padding:0 8px;
                .van-col--6{
                    text-align:center;
                    div{
                        color:#333;
                        font-size:12px;
                        padding-top:6px;
                        padding-bottom:16px;
                    }
                }
            }
            svg {
                margin: 0 auto;
                margin-bottom: 5px;
            }
            a {
                color: #2c3e50;
            }
        }
    }
}

.notifyPopup{
    text-align:center;
    width:90%;
    margin: 0 auto;
    margin-top: 60px;

    h1{
        height: 30px;
        line-height: 30px;
        font-size: 18px;
        margin-bottom: 20px;
    }

    p{
        font-size: 14px;
    }

    .alreadyRead{
        margin-top: 10px;
    }
}
</style>

